import { Box } from "@chakra-ui/react";
import React from "react";

const ErrorPage = () => {
  return <Box></Box>;
};

export default ErrorPage;
